/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Office_Model_StandaloneInputs */

const cs_office_model_standalone = /** @type {(inputs: Office_Model_StandaloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samostatná kancelář`)
};

const en_office_model_standalone = /** @type {(inputs: Office_Model_StandaloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standalone office`)
};

/**
* | output |
* | --- |
* | "Standalone office" |
*
* @param {Office_Model_StandaloneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const office_model_standalone = /** @type {((inputs?: Office_Model_StandaloneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Office_Model_StandaloneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_office_model_standalone(inputs)
	return cs_office_model_standalone(inputs)
});